import React from 'react';
import EducatorLayout from './components/EducatorLayout';
import SupportTicketForm from '../shared/SupportTicketForm';

const EducatorSupport = () => {
  return (
    <EducatorLayout>
      <SupportTicketForm userRole="educator" />
    </EducatorLayout>
  );
};

export default EducatorSupport;
